import { get, ref } from "firebase/database";

export const getXmlDataFromFB = async (database, sessionID) => {
    const infoRef = ref(database, 'SessionsAPI/' + sessionID + '/xmlObj');
    const result = await get(infoRef);

    return result.val();
}